var n=function(n){return"function"==typeof n};export{n as isGenericEventHandler};
